import React from "react";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import { yesOrNoOptions } from "../../../../shared/utility";
import Button from "../../../ui/Button";

const FIELD_CONTROL_CLASS =
  "block w-full min-h-[2.5rem] rounded-xl border border-[#E2E8F0] bg-white px-3 py-2 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10";

function ProductSummaryField({ label, value }) {
  return (
    <div>
      <dt className="text-sm font-medium text-gray-500">{label}</dt>
      <dd className="mt-1 text-sm text-gray-900">{value || "—"}</dd>
    </div>
  );
}

function EditableProductFields({ handleInputChange, values, stacked = false }) {
  return (
    <div
      className={
        stacked
          ? "flex flex-col gap-4 max-w-md"
          : "grid grid-cols-1 sm:grid-cols-2 gap-4"
      }
    >
      <Input
        label="Lot Number"
        name="lot_number"
        onChange={handleInputChange}
        value={values.lot_number}
        labelOn={true}
        type="text"
        className={FIELD_CONTROL_CLASS}
      />
      <SelectMenu
        parentClass="w-full"
        handleInputChange={handleInputChange}
        name="export_eligible"
        options={yesOrNoOptions}
        value={values.export_eligible}
        title={"Export Eligible"}
        showLabel={true}
      />
    </div>
  );
}

export default function ManufactureNewDetails2(props) {
  const {
    handleInputChange,
    values,
    errors,
    productSelectionMode = false,
    onSelectProduct,
  } = props;

  const hasProduct = Boolean(values.product_id);

  if (productSelectionMode) {
    return (
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-gray-600">
            Choose a product to fill PLU, name, and description.
          </p>
          <Button
            type="button"
            variant="secondary"
            size="md"
            onClick={() => onSelectProduct?.()}
          >
            {hasProduct ? "Change product" : "Select product"}
          </Button>
        </div>

        {!hasProduct ? (
          <div className="rounded-xl border border-dashed border-gray-300 bg-gray-50 px-4 py-10 text-center">
            <p className="text-sm font-medium text-gray-900">
              No product selected yet
            </p>
            <p className="mt-1 text-sm text-gray-600">
              Click <span className="font-semibold">Select product</span> to
              browse the catalog.
            </p>
            {errors.product_selection ? (
              <p className="mt-3 text-sm font-medium text-red-600">
                {errors.product_selection}
              </p>
            ) : null}
          </div>
        ) : (
          <div className="rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] p-4">
            <h3 className="mb-3 text-sm font-semibold text-gray-900">
              Selected product
            </h3>
            <dl className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              <ProductSummaryField label="PLU" value={values.plu} />
              <ProductSummaryField
                label="Product name"
                value={values.product_name}
              />
              <ProductSummaryField
                label="Description"
                value={values.description_en}
              />
            </dl>
          </div>
        )}

        <EditableProductFields
          stacked
          handleInputChange={handleInputChange}
          values={values}
        />
      </div>
    );
  }

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="col-span-2">
          <Input
            label="Plu"
            name="plu"
            onChange={handleInputChange}
            value={values.plu}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
            error={errors.plu}
          />
        </div>
        <div className="col-span-2">
          <Input
            label="Product Name"
            name="product_name"
            onChange={handleInputChange}
            value={values.product_name}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
            error={errors.product_name}
          />
        </div>
        <div className="col-span-2">
          <Input
            label="Description"
            name="description_en"
            onChange={handleInputChange}
            value={values.description_en}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
          />
        </div>
        <div className="col-span-2">
          <Input
            label="Lot Number"
            name="lot_number"
            onChange={handleInputChange}
            value={values.lot_number}
            labelOn={true}
            type="text"
            className={FIELD_CONTROL_CLASS}
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            parentClass="w-full"
            handleInputChange={handleInputChange}
            name="export_eligible"
            options={yesOrNoOptions}
            value={values.export_eligible}
            title={"Export Eligible"}
            showLabel={true}
          />
        </div>
      </div>
    </div>
  );
}
